module.exports = __webpack_public_path__ + "static/preciousdaughter-451c2fae87e5a7d521150e7c49ad3f94.jpeg";